<template>
    <li>
        <a :href="player_base_route + player.id" class="clearfix">
            <span class="name">{{ player.first_name }} {{ player.last_name }}</span>
            <span class="badge"><img :src="player.team_logo_path" alt="Club"></span>
            <span class="nation"><img :src="player.flag_path" :alt="player.nationality"></span>
            <span class="position">{{ player.nationality }}</span>
        </a>
    </li>
</template>

<script>
    export default {
        props: ['player', 'player_base_route'],
    }
</script>
